import 'izitoast/dist/css/iziToast.css';

import iziToast from 'izitoast';

const TOAST_TIMEOUT = 10000;

iziToast.settings({
  timeout: TOAST_TIMEOUT,
  resetOnHover: true,
  progressBar: false,
  progressBarColor: 'white',
  transitionIn: 'fadeInUp',
  transitionOut: 'fadeOutDown',
  position: 'bottomCenter',
  displayMode: 'replace',
  pauseOnHover: true,
});

export function success({ title, message }) {
  iziToast.success({
    title,
    message,
  });
}

export function stopSuccessToast(title) {
  iziToast.success({
    title,
    icon: 'toast-success',
    class: 'toast',
    progressBar: true,
    transitionIn: 'fadeInLeft',
    transitionOut: 'fadeOutRight',
    position: 'topRight',
    displayMode: 'replace',
  });
}

export function error({ title, message }) {
  iziToast.error({
    title,
    message,
  });
}

export function warning({ title = '', message }) {
  iziToast.warning({
    title,
    message,
  });
}

export function info({
  title = '',
  message,
  time,
  buttons = '',
  close = true,
  resetOnHover = true,
  pauseOnHover = true,
  progressBar = false,
}) {
  iziToast.info({
    title,
    message,
    color: '#CCE5FF',
    icon: '',
    messageColor: '#212529',
    timeout: time || TOAST_TIMEOUT,
    buttons,
    close,
    resetOnHover,
    pauseOnHover,
    progressBar,
  });
}

export const formErrorToast = (formik, formLabel) => {
  formik.validateForm().then(result => {
    const requiredKeys = Object.keys(result);
    const labelList = [];
    requiredKeys.forEach(field => {
      if (field in formLabel) {
        labelList.push(formLabel[field]);
      }
    });
    if (labelList.length > 0)
      error({
        title: 'Required fields missing:',
        message: `${labelList.slice(0, 4).join(', ')}${labelList.length > 4 ? ' and others' : ''}`,
      });
  });
};
